import { Lottie } from '@rhg/libs/lottie-react';
import checkDark from '@rhg/libs/lottie-react/animations/success-check-dark';
import checkLight from '@rhg/libs/lottie-react/animations/success-check-light';
import { useTheme } from '@rhg/libs/material';

export function SuccessCheckAnimation() {
    const {
        palette: { mode },
    } = useTheme();

    return (
        <Lottie
            autoPlay
            loop={false}
            animationData={mode === 'dark' ? checkDark : checkLight}
        />
    );
}
